import React from "react";
import { Navigate, useParams } from "react-router";

import { ProjectDetails } from "./ProjectDetails";
import LoadingSpinner from "../../common/LoadingSpinner";

import { useAppSelector } from "../../redux/hooks";
import {
  getAuthToken,
  getAuthStatus,
  AuthStatus,
} from "../../redux/reducers/auth";
import { getLinkedPages, getUserId } from "../../redux/reducers/user";

import { useMetaData } from "../../utils/useMetaData";
import { useGetProject } from "../../utils/useProject";
import OtherProjectsContainer from "./OtherProjectsContainer";

const ProjectDetailsContainer: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const auth_token = useAppSelector(getAuthToken);
  const auth_status = useAppSelector(getAuthStatus);
  const user_id = useAppSelector(getUserId);
  const loggedInUserMeta = useAppSelector(getLinkedPages);

  const {
    items: { projects: project },
    isLoading,
    uniqueKey,
  } = useGetProject({ auth_token, id }, true);

  useMetaData(
    project?.[0]
      ? {
          title: project[0].name,
          description: project[0].description
            ? project[0].description
            : `SELeCTに掲載中のプロジェクト ${project[0].name} のページです。`,
          imgUrl: project[0].imgs?.[0]?.medium?.url ?? "",
        }
      : undefined
  );

  if (isLoading) {
    return <LoadingSpinner space={1} />;
  } else if (project && project.length !== 0 && id) {
    return (
      <ProjectDetails
        id={project[0].id}
        title={project[0].name}
        type={project[0].type}
        ownerId={project[0].owner}
        ownerName={project[0].owner_name}
        ownerChatDenial={project[0].owner_chat_denial}
        question={project[0].confirmations}
        imgs={
          project?.[0]?.imgs ? project[0].imgs.map((img) => img.large.url) : []
        }
        applicants={project[0].applicants}
        end_date={project[0].end_date}
        game={project[0].game}
        description={project[0].description}
        requirements={project[0].requirements}
        isUserLoggedIn={auth_status === AuthStatus.Authenticated ? true : false}
        isUsersOwnProject={
          loggedInUserMeta?.project?.includes(project[0].id) ? true : false
        }
        isUserApplied={
          user_id && project[0].applicants.includes(user_id) ? true : false
        }
        refetchKey={uniqueKey}
        isJikei={
          project[0].role_restriction.includes("jikei_student") ? true : false
        }
        relatedContents={<OtherProjectsContainer emitId={id} />}
      />
    );
  } else {
    return <Navigate to="/404" replace />;
  }
};

export default ProjectDetailsContainer;
